import { setHeader } from 'h3';

import { apiGetMostRelevantSaleByVehicleCode, apiGetMostRelevantSaleByVin, SellingMethod } from '~/apiClient';
import { ROUTE_NAMES } from '~/constants/routes';

const SDP_SALE_CHANNEL_TO_ROUTE_NAME_MAP = {
    [SellingMethod.Auction]: ROUTE_NAMES.AUCTION_DETAIL,
    [SellingMethod.DirectSale]: ROUTE_NAMES.DIRECT_SALE_DETAIL,
    [SellingMethod.OfflineSale]: null,
    [SellingMethod.DealerSale]: null,
};

export default defineNuxtRouteMiddleware(async to => {
    const localePath = useLocalePath();
    const { logError } = useLogs();

    // Shared by both vehicle smart links: `/go/c/[vehicleCode]` and the older `/go/v/[vin]`.
    const vehicleCode = 'vehicleCode' in to.params ? String(to.params.vehicleCode) : undefined;
    const vin = 'vin' in to.params ? String(to.params.vin) : undefined;
    if (!vehicleCode && !vin) return abortNavigation({ status: 404 });

    if (import.meta.server) {
        const event = useRequestEvent();
        event && setHeader(event, 'X-Robots-Tag', 'noindex, nofollow');
    }

    try {
        const { sellingMethod, slug } = vehicleCode
            ? await apiGetMostRelevantSaleByVehicleCode(vehicleCode)
            : await apiGetMostRelevantSaleByVin(vin!);
        const routeName = SDP_SALE_CHANNEL_TO_ROUTE_NAME_MAP[sellingMethod];

        if (!routeName) {
            logError('Error in resolving SDP page for vehicle smart link', { vehicleCode, vin, sellingMethod, slug });

            return abortNavigation({ status: 500 });
        }

        return navigateTo(localePath({ name: routeName, params: { slug }, query: { ...to.query, utm_type: 'smartLink' } }), { redirectCode: 302 });
    } catch (error) {
        if (isFetchError(error) && error.status && error.status < 500) {
            return abortNavigation({ status: 404 });
        }

        logError('Error in GetMostRelevantSale API for vehicle smart link', { vehicleCode, vin, error });

        return abortNavigation({ status: 500 });
    }
});
